
import React, { 

    useState, 
    useEffect,
    useRef,
    //useMemo,
    //useCallback

} from 'react';


import { useWindowDimensions } from 'utils/hooks/WindowDimensionsProvider';

import { useLiqGrid } from 'utils/hooks/LiquidFormula/LiqGrid';


import 'app-style/alfabase.css';//alfa,base,tab,tab-x,flank
import StylFlyr from './Flyr.module.css';


import { LibElem } from 'library';



const FGridFlyr = (props) => {
   

    /*

    handle      = {(v) => handle(v)}       
    data       = {imageData}

    */




    //console.log("PROPS DATA :::::::::"+JSON.stringify(props.data,null,2));
    //alert('props');



    // -- window dims -- //
    const { width, height } = useWindowDimensions();


    // -- router -- //
    //let match = useRouteMatch();
    //let location = useLocation();
    //let history = useHistory();


    // -- redux -- //

    //const dispatch = useDispatch();
    //const zoneObj = useSelector(state => state.zone);
    //console.log("zoneObj: "+JSON.stringify(zoneObj, null, 2));

    //if(zoneObj['handle'] && zoneObj['handle'] !== undefined) alert(zoneObj['handle']);



    // -- memo version -- //
    // const setRef = (ref) => {

    //     if(ref && ref !== null && ref !== undefined)
    //     {
    //         //console.log("ref::::"+ref.id);
    //         var found;
    //         found = false;
    //         for(var i=0; i < cellRefs.length; i++)
    //         {
    //             if(cellRefs[i].id === ref.id) found = true;
    //         }
    //         if(!found) cellRefs.push(ref);
    //         //console.log(cellRefs.length);

    //     }

    // };
    // const cellRefs = useMemo(() => setRef(), [setRef]);




    // -- callback version -- //

    //const [cellRefs] = useState([]);
    // const setRef = useCallback((ref) => {

    //     console.log("cellRefs: "+cellRefs);
    //     console.log("ref;"+ref);

    //     setCellRefs([]);


    // }, [cellRefs]);






    // -- state -- //
    const [highZ, setHighZ] = useState(0)

    useEffect(() => {
        
        //setFlyrHeight(flyrRef.current.offsetHeight);
        if(highZ === 0)
        {
            var z = LibElem.HighestZ();
            setHighZ(z)

        }

    }, [highZ])





    // -- ref -- //
    const baseRef = useRef(null)
    const flankRef = useRef(null)
    const flyrRef = useRef(null)


    // -- state -- //
    const [isLoaded,setIsLoaded] = useState(false);
    const [baseScrollHeight, setBaseScrollHeight] = useState(0);
    const [flyrHeight, setFlyrHeight] = useState(10);


    // -- multi refs -- //

    const [cellRefs] = useState([]);
    const setRef = (ref) => {

        if(ref && ref !== null && ref !== undefined)
        {
            //console.log("ref::::"+ref.id);
            var found;
            found = false;
            for(var i=0; i < cellRefs.length; i++)
            {
                if(cellRefs[i].id === ref.id) found = true;
            }
            if(!found) cellRefs.push(ref);
            //console.log(cellRefs.length);

        }

    };




    useEffect(() => {


        if(!isLoaded)
        {

            setIsLoaded(true);

            var total;

            if(props.data.items.length === 1)
            {

                if(flyrHeight < 100 || flyrHeight < height)
                {
                    setBaseScrollHeight(baseRef.current.scrollHeight);
                    setFlyrHeight(flyrRef.current.offsetHeight);

                    if(cellRefs.length === props.data.items.length)
                    {
                        total = 0;
                        if(cellRefs[0] 
                        && cellRefs[0] !== null 
                        && cellRefs[0] !== undefined
                        )
                        {
                            total = total + cellRefs[0].offsetHeight;
                        }
                        setFlyrHeight(total+100);
                    }

                    if(flyrHeight < baseRef.current.scrollHeight) setFlyrHeight(baseRef.current.scrollHeight);

                }//==


            }else{

                setBaseScrollHeight(baseRef.current.scrollHeight);
                setFlyrHeight(flyrRef.current.offsetHeight)

                if(cellRefs.length === props.data.items.length)
                {
                    total = 0;
                    for(var i=0; i < cellRefs.length; i++)
                    {
                        if(cellRefs[i] 
                        && cellRefs[i] !== null 
                        && cellRefs[i] !== undefined
                        )
                        {
                            total = total + cellRefs[i].offsetHeight;
                        }
                    }
                    //flyrRef.current.height = total + "px";
                    //flankRef.current.height = total + "px";

                    setFlyrHeight(total+100);

                }
                
                if(props.data.items.length > 1 && cellRefs.length > 0)
                {
                    //position = props.data.position;

                    //var flyrCell = cellRefs[position];
                    //console.log("POSITION::: "+position+" \noffsetTop: "+flyrCell.offsetTop);

                    var flyrCell;
                    flyrCell = cellRefs[0];

                    for(var cell of cellRefs)
                    {
                        //console.log(cell.id+"==="+props.data.id);
                        if(cell.id.toString() === props.data.id.toString())
                        {
                            flyrCell = cell;
                            break;
                        }
                    }
                    //alert(props.data.id);
                    baseRef.current.scrollTop = flyrCell.offsetTop;

                }

                if(flyrHeight < baseRef.current.scrollHeight-200) setFlyrHeight(baseRef.current.scrollHeight);

            }

        }// -- isLoaded



    },[

        height,
        props,
        isLoaded,
        cellRefs,
        flyrHeight,
        baseScrollHeight
    ])

   





    //console.log(JSON.stringify(props.items));
    //alert("checking utils/FGrid/Flyr")


    var maxWidth = 900;
    if(width < maxWidth + 50)
    {
       maxWidth = width;

    }//==




    //###########################################################
    //###########################################################

    var gridObj;
    gridObj = useLiqGrid(props.data.items, {


        call:'flex', //fixed, flex
        gridType: "ImageOnly", //ImageOnly, ImageText

        gridBgColor:'transparent',
        gridCall: "flyr",  //grid_column_cell or grid_cell or flyr
        modCall: 'fitTo',
        thumb: {

            call    : "flex_height", //flex_height or default
            diff    : 0

        },    
        cellBorder: {
            "boolean"       :true,
            "thickness"     :1,//px
            "color"         :"gray"  
        },
        gutter: {
            "boolean"   :true,
            "size"      :0
        },
        thresh: {
            "refWidth"    :maxWidth,   //number or false = default screen width
            "across1"     :501,
            "across2"     :801,
            "across3"     :1051
        }


    });

    const items = gridObj['items'];

    //console.log(JSON.stringify(items,null,2));
    //alert("checking utils/FGrid/Flyr")





    //###########################################################
    //###########################################################

    var flyrPadBottomInt = 80;
    var flyrPadBottom = flyrPadBottomInt + "px";

     var flyrWInt;
     var flyrW;

     var flyrH;

     var flyrMarl;

     var flyrMartInt;
     var flyrMart;

     var tabMartInt;
     var tabMart;



     flyrWInt = maxWidth;
     flyrMarl = (width - flyrWInt)/2 + "px";

     if(width < flyrWInt+50)
     {
        flyrWInt = width;
        flyrMarl = 0 + "px";
     }//==

     flyrW = flyrWInt + "px";


    //-------------------------------------------

    flyrMartInt = 50;
    tabMartInt = 0;

    flyrMart = flyrMartInt + 'px';
    tabMart = tabMartInt + "px";

    //-------------------------------------------

    var flankLeftWidthInt;
    var flankLeftWidth;
    var flankLeftMarl;
       
    var flankRightWidthInt;
    var flankRightWidth;
    var flankRightMarl;

    var flankVertHeight;


    flankLeftWidthInt = (width - flyrWInt)/2;
    flankLeftWidth = flankLeftWidthInt + "px";
    flankLeftMarl = "0px";
       
    flankRightWidthInt = (width - flyrWInt)/2;
    flankRightWidth = flankRightWidthInt + "px";
    flankRightMarl = flankLeftWidthInt + flyrWInt + "px";


    //flyrH = baseScrollHeight - (tabHeight+flyrPadBottomInt) + "px";
    flyrH = flyrHeight + (0) + "px";
    flankVertHeight = flyrHeight + (100) + "px";




    if(items.length === 0)
    {


        return (


            <div>

                <div 
                className="alfa"
                style={{

                    zIndex:highZ+1

                }}
                ></div>

                <div 
                className="base"
                style={{

                    zIndex:highZ+2

                }}
                >

                    Loading...


                </div>


            </div>

        );



    
    }
    else
    {


        return (


            <div>


                <div 
                className="alfa"
                style={{

                    zIndex:highZ+1

                }}
                ></div>

                <div 
                className="tab"
                style={{

                    backgroundColor : 'white', 
                    width           : flyrW,
                    height          : "50px",
                    margin          : "0 0 0 0",
                    top             : tabMart,
                    left            : flyrMarl,
                    zIndex          : highZ+3

                }}
                >


                    <div 
                    className="tab-x" 
                    onClick={() => props.handle({

                        call:'hide'

                    })}
                    >  

                        X

                    </div>


                </div>


                <div 
                id="flyrBase"
                ref={baseRef}
                className="base"
                style={{

                    zIndex:highZ+2

                }}
                >


                    <div 
                    id="flankleft"
                    ref={flankRef}
                    onClick={() => props.handle({

                        call:'hide'

                    })}
                    className="flank" 
                    style={{

                        //backgroundColor : 'blue', 
                        width           : flankLeftWidth,
                        height          : flankVertHeight,
                        left            : flankLeftMarl
                    

                    }}
                    >
                    </div>


                    <div 
                    id="flankright"
                    onClick={() => props.handle({

                        call:'hide'

                    })}
                    className="flank" 
                    style={{

                        //backgroundColor : 'red', 
                        width           : flankRightWidth,
                        height          : flankVertHeight,
                        left            : flankRightMarl

                    }}
                    >
                    </div>





                    <div 
                    id="flyr"
                    ref={flyrRef}
                    className={StylFlyr.ImageFlyr} 
                    style={{

                        backgroundColor : 'white', 
                        width           : flyrW,
                        height          : flyrH,
                        margin          : flyrMart+" 0 0 "+flyrMarl,
                        padding         : "0 0 "+flyrPadBottom+" 0"

                    }}
                    >





                        <div 
                        className={StylFlyr.Grid}
                        style={{

                            //backgroundColor : "lightyellow", 
                            //width           : liqItems.grid.width,
                            //height          : liqItems.grid.height, 

                        }}

                        >

                            {items.data.map((box, i) => (

                                <div 
                                ref={setRef}
                                key={i}   
                                id={box.id}
                                className={StylFlyr.Cell} 
                                style={{

                                    //backgroundColor : box.bgColor, 
                                    width           : items.cell.width,
                                    height          : items.cell.height,
                                    //height          : "300px",
                                    //margin          : items.cell.margin,
                                    //border          : items.cell.border
                            
                        
                                }}
                        
                                >


                                    <div 
                                    className={StylFlyr.Thmb}  
                                    style={{

                                        //backgroundColor:"magenta",
                                        width:"100%",
                                        //height:"62.5%",

                                        //width:items.cell.thumb.width,
                                        //height:items.cell.thumb.height,
                                        //height:box.thumb.h,
                                        height:box.image.maxHeight,


                                        //margin:items.cell.thumb.margin,
                                        overflow:"hidden"

                            
                                    }}
                            
                                    >


                                        {
                                        box.image.src.match(/http/gi) 
                                        ?


                                            <img
                                            style={{

        
                                                flexShrink: 0,

                                                height:"auto",
            
                                                minWidth:box.image.maxWidth,
                                                //minHeight: "100%",
            
                                                maxWidth:"100%",
                                                maxHeight:box.image.maxHeight,
            
                                                marginTop:box.image.top,
                                                marginLeft:box.image.left


                                            }}

                                            src={box.image.src}
                                            //src={window.location.origin + `${process.env.PUBLIC_URL}` + box.image.src} 
                                            //src={window.location.origin + box.image.src} 
                                            //width={box.image.w}
                                            //height={box.image.h} 
                                            alt='(!)'

                                            />




                                        :


                                            <img
                                            style={{

        
                                                flexShrink: 0,

                                                height:"auto",
            
                                                minWidth:box.image.maxWidth,
                                                //minHeight: "100%",
            
                                                maxWidth:"100%",
                                                maxHeight:box.image.maxHeight,
            
                                                marginTop:box.image.top,
                                                marginLeft:box.image.left


                                            }}


                                            src={window.location.origin + `${process.env.PUBLIC_URL}` + box.image.src} 
                                            //src={window.location.origin + box.image.src} 
                                            //width={box.image.w}
                                            //height={box.image.h} 
                                            alt='(!)'

                                            />

                                        }



                                    </div>



                                    {
                                    props.data.gridType === 'ImageText' ? 


                                        <div>
                                            <div className={StylFlyr.Title} >{box.title}</div>
                                            <div className={StylFlyr.Text} >{box.text}</div>
                                        </div>

                                    : null
                                    }


                                </div>



                            ))}


                        </div>

                        




                    </div>

                </div>


            </div>

        );


    }



}


export default FGridFlyr;





/*

  inputRefs = [];
  
    setRef = (ref) => {
        this.inputRefs.push(ref);
    };
    
    focusInput = (id) => this.inputRefs[id].focus();
    
    render() {
        return (
        <div>
            {this.state.data.map(({ name }) => (
            <Hello 
                placeholder={name} 
                ref={this.setRef} 
                key={name} />
            ))}
            <Button onClick={this.focusInput} id={0}>focus input 1</Button>
            <Button onClick={this.focusInput} id={1}>focus input 2</Button>
        </div>
        );
    }
    }

*/